import { render, staticRenderFns } from "./OwnerForm.vue?vue&type=template&id=ad0f5832&scoped=true&"
import script from "./OwnerForm.vue?vue&type=script&lang=js&"
export * from "./OwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerForm.vue?vue&type=style&index=0&id=ad0f5832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0f5832",
  null
  
)

export default component.exports